/* assets/collection-variants.js */
/* Variant resolver for product cards on collection/search/recommendations (quiet + resilient) */
(function () {
  const MONEY_FMT = (window.theme && theme.moneyFormat) || '${{amount}}';

  function formatMoney(cents) {
    const v = (cents || 0) / 100;
    const amt = v.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return MONEY_FMT
      .replace(/\{\{\s*amount\s*\}\}/, amt)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(v) + '');
  }

  function sizeUrl(url, w) {
    if (!url) return url;
    const parts = url.split('?');
    const base = parts[0].replace(/(_\d+x)?\.(jpg|jpeg|png|gif|webp|avif)$/i, `_${w}x.$2`);
    return parts.length > 1 ? `${base}?${parts.slice(1).join('?')}` : base;
  }

  function updateCardImage(card, chosen) {
    const img = card.querySelector('.product-item__primary-image');
    if (!img) return;
    if (!img.__orig) {
      img.__orig = { src: img.getAttribute('src'), srcset: img.getAttribute('srcset') };
    }
    let url = null;
    if (chosen && chosen.featured_image && chosen.featured_image.src) {
      url = chosen.featured_image.src;
    }
    if (!url && chosen) {
      const wrap = card.querySelector('.card-form-wrapper');
      const raw  = wrap && wrap.getAttribute('data-variant-images');
      if (raw) {
        try {
          const map = JSON.parse(raw);
          url = map[String(chosen.id)] || null;
        } catch {}
      }
    }
    if (url) {
      const widths = [200,300,400,600,800,1000,1200,1400,1600];
      const srcset = widths.map(w => `${sizeUrl(url, w)} ${w}w`).join(', ');
      img.src = sizeUrl(url, 800);
      img.setAttribute('srcset', srcset);
      img.setAttribute('sizes', '(max-width: 699px) 100vw, 600px');
      if (chosen.featured_image && chosen.featured_image.alt) img.alt = chosen.featured_image.alt;
    } else {
      if (img.__orig.src)    img.src    = img.__orig.src;
      if (img.__orig.srcset) img.setAttribute('srcset', img.__orig.srcset);
    }
  }

  function readVariants(wrapper) {
    try { return JSON.parse(wrapper.getAttribute('data-variants') || '[]'); }
    catch { return []; }
  }

  function labelText(labelEl) {
    const t = labelEl.querySelector('.block-swatch__item-text');
    return (t ? t.textContent : labelEl.textContent || '').trim();
  }

  function collectGroups(card) {
    const groups = {};
    card.querySelectorAll('fieldset.card-option').forEach(fs => {
      const idx = Number(fs.getAttribute('data-opt-index'));
      const items = [];
      fs.querySelectorAll('label.block-swatch').forEach(lbl => {
        const input = lbl.querySelector('input.product-form__single-selector');
        items.push({ lbl, input, value: labelText(lbl) });
      });
      groups[idx] = items;
    });
    return groups;
  }

  function selected(groups, i) {
    const g = groups[i] || [];
    const hit = g.find(x => x.input.checked);
    return hit ? hit.value : null;
  }

  function matchAvail(variants, f) {
    return variants.filter(v => {
      if (f[1] && v.option1 !== f[1]) return false;
      if (f[2] && v.option2 !== f[2]) return false;
      if (f[3] && v.option3 !== f[3]) return false;
      return v.available;
    });
  }

  function applyAllowed(groups, i, allowedSet) {
    const g = groups[i] || [];
    g.forEach(x => {
      const ok = allowedSet.has(x.value);
      x.input.disabled = !ok;
      x.lbl.classList.toggle('block-swatch--disabled', !ok);
      x.lbl.classList.toggle('is-hidden', !ok);
    });
  }

  function ensureValid(groups, i) {
    const g = groups[i] || [];
    if (!g.length) return;
    const current = g.find(x => x.input.checked && !x.input.disabled && !x.lbl.classList.contains('is-hidden'));
    if (current) return;
    const firstOK = g.find(x => !x.input.disabled && !x.lbl.classList.contains('is-hidden'));
    if (firstOK) {
      firstOK.input.checked = true;
      firstOK.input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function coerceToAvailable(variants, groups) {
    const s1 = selected(groups, 1), s2 = selected(groups, 2), s3 = selected(groups, 3);
    let v = variants.find(w =>
      (!groups[1]?.length || w.option1 === s1) &&
      (!groups[2]?.length || w.option2 === s2) &&
      (!groups[3]?.length || w.option3 === s3) &&
      w.available
    );
    if (v) return v;
    if (groups[3]?.length && s1 && s2) { const c3 = matchAvail(variants, {1:s1,2:s2}); if (c3[0]) return c3[0]; }
    if (groups[2]?.length && s1)      { const c2 = matchAvail(variants, {1:s1});     if (c2[0]) return c2[0]; }
    return variants.find(w => w.available) || null;
  }

  function refreshCard(card) {
    try {
      const form      = card.querySelector('form.card-form');
      const wrapper   = card.querySelector('.card-form-wrapper');
      const priceWrap = card.querySelector('.product-item__price-list');
      const idInput   = form && form.querySelector('input[name="id"]');
      const ctaBtn    = card.querySelector('[data-cta], .product-item__action-button.button--primary');
      const variants  = readVariants(wrapper);
      if (!variants.length || !form || !idInput || !ctaBtn) return;

      const groups = collectGroups(card);
      [2,3].forEach(i => {
        (groups[i] || []).forEach(x => {
          x.input.disabled = false;
          x.lbl.classList.remove('block-swatch--disabled', 'is-hidden');
        });
      });

      const s1 = selected(groups, 1);
      if (groups[2] && s1) {
        const allowed2 = new Set(matchAvail(variants, {1:s1}).map(v => v.option2));
        applyAllowed(groups, 2, allowed2); ensureValid(groups, 2);
      }
      const s2 = selected(groups, 2);
      if (groups[3] && s1 && s2) {
        const allowed3 = new Set(matchAvail(variants, {1:s1,2:s2}).map(v => v.option3));
        applyAllowed(groups, 3, allowed3); ensureValid(groups, 3);
      }

      const chosen = coerceToAvailable(variants, groups);
      updateCardImage(card, chosen);

      // price
      if (chosen && priceWrap) {
        let cur = priceWrap.querySelector('.price--current');
        if (!cur) {
          cur = priceWrap.querySelector('.price') || document.createElement('span');
          cur.classList.add('price', 'price--current');
          if (!cur.parentNode) priceWrap.appendChild(cur);
        }
        cur.innerHTML = `<span class="visually-hidden">Sale price</span>${formatMoney(chosen.price)}`;

        const onSale = chosen.compare_at_price && chosen.compare_at_price > chosen.price;
        let cmp = priceWrap.querySelector('.price--compare');
        if (onSale) {
          if (!cmp) {
            cmp = document.createElement('span');
            cmp.className = 'price price--compare';
            priceWrap.appendChild(cmp);
          }
          cmp.innerHTML = `<span class="visually-hidden">Regular price</span>${formatMoney(chosen.compare_at_price)}`;
        } else if (cmp) {
          cmp.remove();
        }
      }

      if (chosen) {
        idInput.value = chosen.id;
        ctaBtn.type = 'submit';
        ctaBtn.textContent = (card.dataset.preorder === 'true') ? 'Pre-order' : 'Add to cart';
        ctaBtn.classList.remove('button--disabled');
      } else {
        idInput.value = '';
        ctaBtn.type = 'button';
        ctaBtn.textContent = 'Choose options';
      }
    } catch (e) {
      // never let a single card crash the page
      console && console.debug && console.debug('[cv] refresh error', e);
    }
  }

  function bindCard(card) {
    if (!card || !(card instanceof Element)) return;

    // isolate radio groups per card (prevents Flickity clone loops)
    if (!card.dataset.cvuid) {
      card.dataset.cvuid = 'cv' + Math.random().toString(36).slice(2);
      card.querySelectorAll('input.product-form__single-selector').forEach(inp => {
        const base = inp.name.replace(/__cvuid-[A-Za-z0-9]+$/, '');
        inp.name = base + '__cvuid-' + card.dataset.cvuid;
      });
    }

    if (card.dataset.cvBound === '1') return;
    card.dataset.cvBound = '1';

    if (!document.__cvCss) {
      const st = document.createElement('style');
      st.textContent = `.block-swatch.is-hidden{display:none!important}`;
      document.head.appendChild(st);
      document.__cvCss = true;
    }

    card.addEventListener('change', (e) => {
      if (e.target?.classList?.contains('product-form__single-selector')) {
        refreshCard(card);
      }
    });

    refreshCard(card);
  }

  function boot(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.product-item:not([data-cv-bound])').forEach(bindCard);
  }

  // expose boot so theme/events can call directly
  window.__cvBoot = boot;

  // Initial
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
  else boot();

  // Theme/Shopify hooks
  document.addEventListener('shopify:section:load', (e) => boot(e.target || document));
  document.addEventListener('shopify:section:reloaded', (e) => boot(e.target || document));
  document.addEventListener('shopify:paginate', () => boot());
  document.addEventListener('ajax:complete', () => boot());

  // IMPORTANT: recommendations are injected async
  document.addEventListener('product-recommendations:updated', (e) => boot(e.target || document));

  // MutationObserver fallback — detects new product cards added anywhere
  let raf = 0;
  const observeNewCards = (nodes) => {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(() => {
      nodes.forEach(node => {
        if (!(node instanceof Element)) return;
        node.querySelectorAll && node.querySelectorAll('.product-item:not([data-cv-bound])').forEach(bindCard);
        if (node.matches && node.matches('.product-item:not([data-cv-bound])')) bindCard(node);
      });
    });
  };
  new MutationObserver((mutations) => {
    const added = [];
    mutations.forEach(m => added.push(...m.addedNodes));
    if (added.length) observeNewCards(added);
  }).observe(document.body, { childList: true, subtree: true });
})();
